'use client';

import { apiFetch } from '@/lib/api/apiClient';
import { useAuthStore } from '@/stores/useAuthStore';
import { useBoardEditorFileStore } from '@/stores/useBoardEditorFileStore';
import { useBoardEditorStore } from '@/stores/useBoardEditorStore';

export function useAuthLogout() {
    async function logout() {
        try {
            await apiFetch('/auth/logout', { method: 'POST' });
        } catch (error) {
            void error;
        } finally {
            useAuthStore.getState().resetAuth();

            useBoardEditorStore.getState().resetEditor();
            useBoardEditorFileStore.getState().setFiles([]);
            useBoardEditorFileStore.getState().setCurrentFile(null);

            if (typeof window !== 'undefined') {
                Object.keys(window.localStorage)
                    .filter((key) => key.startsWith('KEY-') && key !== 'KEY-THEME-COLOR')
                    .forEach((key) => window.localStorage.removeItem(key));
            }
        }
    }

    return { logout };
}
